import blankRAViews from '../../components/BlankRAViews';

import TeammatesList from './teammates-list';
import TeammatesCreate from './teammates-create';

export default {
  ...blankRAViews,
  create: TeammatesCreate,
  list: TeammatesList,
};
